import { CompanyType } from "../types/companyManagementTypes";
import { EmployeeUserType } from "../types/employeeType";
import { CallResult, doApiGet, doApiPost, doApiPatch, doApiDelete } from "./Requests";

export const subcompaniesApi = {
  getSubCompanies: async (): Promise<CallResult<CompanyType[]>> => {
    return await doApiGet<CompanyType[]>("/api/companies/current/subCompanies");
  },

  createSubCompany: async (
    subCompanyData: Omit<CompanyType, "id">
  ): Promise<CallResult<CompanyType>> => {
    return await doApiPost("/api/companies/current/subCompanies", subCompanyData);
  },

  editSubCompany: async (
    id: number,
    subCompanyData: Omit<CompanyType, "id">
  ): Promise<CallResult<CompanyType>> => {
    return await doApiPatch(`/api/companies/current/subCompanies/${id}`, subCompanyData);
  },

  deleteSubCompany: async (
    id: number
  ): Promise<CallResult<null>> => {
    return await doApiDelete(`/api/companies/current/subCompanies/${id}`);
  },

  getSubCompanyEmployees: async (
    subCompanyId: number
  ): Promise<CallResult<EmployeeUserType[]>> => {
    return await doApiGet<EmployeeUserType[]>(
      `/api/companies/current/subcompanies/${subCompanyId}/employees`
    );
  },
};
